
        import * as module0 from './amazon_export_controller.js'
        export default [module0.default];
        export const context = {
          'amazon_export_controller.js': module0.default
        }
      